// Traduzioni per il Museo Stibbert Shop
export const translations = {
  it: {
    // Header
    'header.home': 'Home',
    'header.museum_site': 'Sito Museo',
    'header.cart': 'Carrello',
    
    // Home Page
    'home.title': 'Benvenuti al Museo Stibbert',
    'home.subtitle': 'Scopri la nostra collezione di prodotti unici',
    'home.hero.title': 'Museo Stibbert',
    'home.hero.subtitle': 'Arte, Storia e Tradizione',
    'home.products.title': 'I Nostri Prodotti',
    'home.products.subtitle': 'Scopri la nostra collezione esclusiva',
    'home.filters.search': 'Cerca prodotti...',
    'home.filters.category': 'Tutte le categorie',
    'home.filters.price_min': 'Prezzo minimo',
    'home.filters.price_max': 'Prezzo massimo',
    'home.filters.reset': 'Reset Filtri',
    'home.filters.filters': 'Filtri',
    'home.filters.price': 'Prezzo',
    'home.filters.category_label': 'Categoria',
    'home.filters.availability': 'Disponibilità',
    'home.filters.availability_all': 'Tutti i prodotti',
    'home.filters.availability_in_stock': 'Solo disponibili',
    'home.filters.availability_out_of_stock': 'Solo esauriti',
    'home.filters.from': 'Da',
    'home.filters.to': 'A',
    'home.sort.order_by': 'Ordina per',
    'home.sort.most_recent': 'Più recenti',
    'home.sort.price_low': 'Prezzo crescente',
    'home.sort.price_high': 'Prezzo decrescente',
    'home.sort.name_az': 'Nome A-Z',
    'home.sort.name_za': 'Nome Z-A',
    'home.empty': 'Nessun prodotto trovato con i filtri selezionati.',
    'home.error': 'Errore nel caricamento dei prodotti.',
    'home.retry': 'Riprova',
    'home.products_found': 'prodotti trovati',
    
    // Product Card
    'product.add_to_cart': 'Aggiungi al Carrello',
    'product.view_details': 'Visualizza Dettagli',
    'product.price': 'Prezzo',
    'product.category': 'Categoria',
    'product.stock_available': '{quantity} pezzi disponibili',
    'product.out_of_stock': 'Al momento non disponibile',
    'product.out_of_stock_short': 'Non disponibile',
    
    // Product Detail Page
    'product.title': 'Dettagli Prodotto',
    'product.back': 'Torna ai Prodotti',
    'product.quantity': 'Quantità',
    'product.description': 'Descrizione',
    'product.images': 'Immagini',
    'product.loading': 'Caricamento prodotto...',
    'product.error': 'Errore nel caricamento del prodotto.',
    'product.not_found': 'Prodotto non trovato.',
    'product.buy_now': 'Acquista Ora',
    'product.similar_products': 'Prodotti Simili',
    
    // Cart Page
    'cart.title': 'Il Tuo Carrello',
    'cart.empty': 'Il tuo carrello è vuoto',
    'cart.empty_subtitle': 'Aggiungi alcuni prodotti per iniziare lo shopping!',
    'cart.shop_now': 'Inizia a Comprare',
    'cart.item': 'Prodotto',
    'cart.quantity': 'Quantità',
    'cart.price': 'Prezzo',
    'cart.total': 'Totale',
    'cart.subtotal': 'Subtotale',
    'cart.shipping': 'Spedizione',
    'cart.shipping_free': 'Gratuita',
    'cart.shipping_loading': 'Calcolo in corso...',
    'cart.shipping_error': 'Errore nel recupero della spedizione',
    'cart.shipping_warning': 'Impossibile calcolare la spedizione, verrà applicato temporaneamente un costo pari a 0€.',
    'cart.free_shipping_unlocked': 'Complimenti! La spedizione è gratuita.',
    'cart.free_shipping_missing': 'Aggiungi ancora {amount}€ per ottenere la spedizione gratuita.',
    'cart.shipping_destination': 'Destinazione stimata',
    'cart.shipping_destination_hint': "Scegli un'area per stimare la spedizione; al checkout useremo l'indirizzo reale.",
    'cart.checkout': 'Procedi al Checkout',
    'cart.clear_cart': 'Svuota Carrello',
    'cart.remove_item': 'Rimuovi',
    'cart.item_stock_left': 'Ancora {quantity} disponibili',
    'cart.item_out_of_stock': 'Al momento finiti',
    'cart.order_summary': 'Riepilogo Ordine',
    'cart.subtotal': 'Subtotale',
    'cart.continue_shopping': 'Continua lo Shopping',
    
    // Checkout Page
    'checkout.title': 'Checkout',
    'checkout.back_to_cart': 'Torna al Carrello',
    'checkout.shipping_details': 'Dati di Spedizione',
    'checkout.order_summary': 'Riepilogo Ordine',
    'checkout.complete_payment': 'Completa il Pagamento',
    'checkout.total': 'Totale',
    'checkout.form.name': 'Nome',
    'checkout.form.surname': 'Cognome',
    'checkout.form.email': 'Email',
    'checkout.form.phone': 'Telefono',
    'checkout.form.street': 'Via',
    'checkout.form.number': 'Civico',
    'checkout.form.postal_code': 'CAP',
    'checkout.form.city': 'Città',
    'checkout.form.province': 'Provincia',
    'checkout.form.state': 'Stato',
    'checkout.form.required': 'Compila tutti i campi obbligatori per procedere al pagamento',
    'checkout.payment_methods': 'Metodi di pagamento',
    'checkout.payment_methods_desc': 'Nexi, Carte di Credito/Debito',
    'checkout.security': 'Sicurezza',
    'checkout.security_desc': 'Il pagamento è gestito da Nexi su pagina sicura',
    'checkout.subtotal': 'Subtotale',
    'checkout.shipping': 'Spedizione',
    'checkout.shipping_free': 'Gratuita',
    'checkout.shipping_loading': 'Calcolo spedizione in corso...',
    'checkout.shipping_error': 'Impossibile calcolare la spedizione. Riprova tra qualche istante.',
    'checkout.shipping_warning': 'Impossibile calcolare la spedizione, verrà considerata gratuita fino alla risoluzione del problema.',
    'checkout.free_shipping_unlocked': 'Spedizione gratuita attivata!',
    'checkout.free_shipping_missing': 'Ti mancano {amount}€ per la spedizione gratuita.',
    'checkout.detected_zone': 'Destinazione rilevata: {zone}',
    'checkout.detected_zone_hint': 'Compila il campo "Stato" per aggiornare automaticamente costi e soglia.',
    'checkout.terms_intro': 'Ho letto, compreso e accettato le',
    'checkout.terms_conditions': 'Condizioni Generali di Acquisto',
    'checkout.terms_connector': 'e le',
    'checkout.terms_privacy': 'Norme di Protezione dei Dati Personali in conformità al GDPR 2016/679',
    'checkout.terms_warning': "In caso di mancato consenso, l'acquisto non può aver luogo.",
    'checkout.terms_error': 'Per procedere è necessario accettare le condizioni e le norme sulla protezione dei dati.',
    'checkout.pay_with_nexi': 'Paga con Nexi',
    'checkout.redirect_to_nexi': 'Verrai reindirizzato alla cassa sicura Nexi per completare il pagamento.',
    'checkout.processing_payment': 'Reindirizzamento in corso...',
    'checkout.success.title': 'Ordine Completato!',
    'checkout.success.message': 'Il tuo ordine è stato elaborato con successo.',
    'checkout.success.redirect': 'Verrai reindirizzato alla home page tra qualche secondo...',
    
    // Nexi Result / Cancel
    'nexi.result.verifying': 'Verifica del pagamento in corso',
    'nexi.result.wait_message': 'Stiamo attendendo la conferma di Nexi. Questo processo potrebbe richiedere qualche secondo.',
    'nexi.result.success_title': 'Pagamento completato!',
    'nexi.result.success_message': 'Abbiamo ricevuto il tuo ordine. Ti invieremo una conferma via email a breve.',
    'nexi.result.failed_title': 'Pagamento non completato',
    'nexi.result.error_generic': 'Si è verificato un problema durante la verifica del pagamento.',
    'nexi.result.invalid_order': 'Ordine non valido o mancante.',
    'nexi.result.not_confirmed': 'Pagamento non ancora confermato da Nexi. Se hai già pagato, contattaci.',
    'nexi.result.back_home': 'Torna alla Home',
    'nexi.result.back_checkout': 'Torna al Checkout',
    'nexi.cancel.title': 'Pagamento annullato',
    'nexi.cancel.message': 'Hai annullato il pagamento su Nexi. Puoi riprovare in qualsiasi momento.',
    'nexi.cancel.back_checkout': 'Riprova il pagamento',
    'nexi.cancel.back_home': 'Torna alla Home',
    
    // Footer
    'footer.contacts': 'Contatti',
    'footer.address': 'Via Federigo Stibbert, 26',
    'footer.hours': 'Orari Museo',
    'footer.hours_desc': 'Lun - Mer: 10:00 - 14:00',
    'footer.useful_links': 'Link Utili',
    'footer.museum_site': 'Sito Museo',
    
    // Common
    'common.loading': 'Caricamento...',
    'common.error': 'Errore',
    'common.success': 'Successo',
    'common.cancel': 'Annulla',
    'common.confirm': 'Conferma',
    'common.save': 'Salva',
    'common.edit': 'Modifica',
    'common.delete': 'Elimina',
    'common.close': 'Chiudi',
    'common.back': 'Indietro',
    'common.next': 'Avanti',
    'common.previous': 'Precedente',
    'common.required': 'Obbligatorio',
    'common.optional': 'Opzionale',
    
    // Terms Page
    'terms.title': 'Condizioni Generali di Acquisto',
    'terms.last_update': 'Ultimo aggiornamento:',
    'terms.section_1_title': '1. Informazioni Generali',
    'terms.section_1_content': 'Questo documento definisce i termini e le condizioni che regolano l\'utilizzo e la vendita di prodotti come libri e gadget sul sito e-commerce di Fondazione Museo Stibbert ets. di seguito Museo Stibbert. Accedendo al sito e completando un ordine, l\'utente accetta integralmente i presenti Termini e Condizioni.',
    'terms.section_2_title': '2. Oggetto del Servizio',
    'terms.section_2_content': 'Il sito consente agli utenti di acquistare gadget ufficiali del Museo Stibbert, quali articoli da regalo, prodotti editoriali, abbigliamento e altri articoli di merchandising.',
    'terms.section_3_title': '3. Prodotti e Disponibilità',
    'terms.section_3_content': 'Le descrizioni e le immagini dei prodotti sono indicative e potrebbero non rappresentare perfettamente il prodotto finale. La disponibilità dei prodotti è indicata sul sito, ma non può essere garantita fino alla conferma dell\'ordine.',
    'terms.section_4_title': '4. Prezzi e Pagamenti',
    'terms.section_4_content': 'Tutti i prezzi sono espressi in euro (€) e sono comprensivi di IVA, salvo diversa indicazione. Il pagamento può essere effettuato tramite carte di credito e debito del circuito Visa e Mastercard in modo sicuro tramite il circuito di pagamento Nexi. L\'ordine si considera accettato solo dopo la conferma del pagamento.',
    'terms.section_5_title': '5. Spedizioni e Consegna',
    'terms.section_5_content': 'Le spese di spedizione sono indicate nel corso della procedura d\'acquisto. I tempi di consegna, specificati durante l\'acquisto, sono indicativi e possono variare in base al corriere e alla destinazione. Le consegne vengono effettuate all\'indirizzo indicato dall\'utente e il Museo Stibbert non risponde di eventuali errori di consegna derivanti da inesattezze ed errori da parte dell\'utente. Il Museo Stibbert non è responsabile di ritardi indipendenti dal proprio controllo. Al momento della consegna gli utenti devono verificare l\'integrità del pacco ed il suo contenuto. In caso di anomalie dovranno firmare la bolla del corriere con riserva specifica e fare immediatamente una segnalazione all\'indirizzo bookshop@museostibbert.it.',
    'terms.section_6_title': '6. Diritto di Recesso',
    'terms.section_6_content': 'Ai sensi della normativa vigente, l\'utente può esercitare il diritto di recesso entro 14 giorni dalla consegna, salvo eccezioni previste dalla legge, dandone comunicazione scritta a Museo Stibbert all\' indirizzo bookshop@museostibbert.it ed, utilizzando un vettore a propria scelta, restituire entro 14 giorni il prodotto opportunamente imballato a: Bookshop Museo Stibbert, via di Montughi, 4 50139 Firenze. Le spese di restituzione sono a carico dell\'utente. Il rimborso sarà effettuato dopo aver verificato l\'integrità dei prodotti restituiti.',
    'terms.section_7_title': '7. Garanzia dei Prodotti',
    'terms.section_7_content': 'I prodotti sono coperti da garanzia legale secondo la normativa italiana. Eventuali difetti devono essere segnalati entro i termini previsti.',
    'terms.section_9_title': '9. Limitazioni di responsabilità',
    'terms.section_9_content': 'Il Museo Stibbert non è responsabile per danni derivanti da uso improprio dei prodotti acquistati né per inadempienze, disservizi o ritardi dovuti a cause di forza maggiore. In ogni caso la responsabilità di Museo Stibbert non potrà eccedere le somme pagate dall\'utente al Museo Stibbert per l\'acquisto.',
    'terms.section_11_title': '11. Proprietà Intellettuale',
    'terms.section_11_content': 'Tutti i contenuti presenti sul sito (testi, immagini, marchi, loghi) sono di proprietà del Museo Stibbert o concessi in licenza. Ne è vietato l\'uso non autorizzato.',
    'terms.section_12_title': '12. Privacy e Protezione dei Dati',
    'terms.section_12_content': 'Il trattamento dei dati personali è regolato dall\'Informativa Privacy pubblicata sul sito. L\'utente è invitato a consultarla per maggiori dettagli.',
    'terms.section_13_title': '13. Legge Applicabile e Foro Competente',
    'terms.section_13_content': 'I presenti Termini e Condizioni sono regolati dalla legge italiana. Per eventuali controversie sarà competente il foro del consumatore, salvo quanto previsto dalla normativa vigente per casi particolari.',
    'terms.section_14_title': '14. Modifiche ai Termini e Condizioni',
    'terms.section_14_content': 'Il Museo Stibbert si riserva il diritto di modificare in qualsiasi momento i presenti Termini e Condizioni. Le modifiche entreranno in vigore dalla data di pubblicazione sul sito.'
  },
  
  en: {
    // Header
    'header.home': 'Home',
    'header.museum_site': 'Museum Site',
    'header.cart': 'Cart',
    
    // Home Page
    'home.title': 'Welcome to Stibbert Museum',
    'home.subtitle': 'Discover our unique collection of products',
    'home.hero.title': 'Stibbert Museum',
    'home.hero.subtitle': 'Art, History and Tradition',
    'home.products.title': 'Our Products',
    'home.products.subtitle': 'Discover our exclusive collection',
    'home.filters.search': 'Search products...',
    'home.filters.category': 'All categories',
    'home.filters.price_min': 'Minimum price',
    'home.filters.price_max': 'Maximum price',
    'home.filters.reset': 'Reset Filters',
    'home.filters.filters': 'Filters',
    'home.filters.price': 'Price',
    'home.filters.category_label': 'Category',
    'home.filters.availability': 'Availability',
    'home.filters.availability_all': 'All products',
    'home.filters.availability_in_stock': 'In stock only',
    'home.filters.availability_out_of_stock': 'Sold out only',
    'home.filters.from': 'From',
    'home.filters.to': 'To',
    'home.sort.order_by': 'Sort by',
    'home.sort.most_recent': 'Most recent',
    'home.sort.price_low': 'Price low to high',
    'home.sort.price_high': 'Price high to low',
    'home.sort.name_az': 'Name A-Z',
    'home.sort.name_za': 'Name Z-A',
    'home.empty': 'No products found with the selected filters.',
    'home.error': 'Error loading products.',
    'home.retry': 'Retry',
    'home.products_found': 'products found',
    
    // Product Card
    'product.add_to_cart': 'Add to Cart',
    'product.view_details': 'View Details',
    'product.price': 'Price',
    'product.category': 'Category',
    'product.stock_available': '{quantity} pcs available',
    'product.out_of_stock': 'Currently unavailable',
    'product.out_of_stock_short': 'Sold out',
    
    // Product Detail Page
    'product.title': 'Product Details',
    'product.back': 'Back to Products',
    'product.quantity': 'Quantity',
    'product.description': 'Description',
    'product.images': 'Images',
    'product.loading': 'Loading product...',
    'product.error': 'Error loading product.',
    'product.not_found': 'Product not found.',
    'product.buy_now': 'Buy Now',
    'product.similar_products': 'Similar Products',
    
    // Cart Page
    'cart.title': 'Your Cart',
    'cart.empty': 'Your cart is empty',
    'cart.empty_subtitle': 'Add some products to start shopping!',
    'cart.shop_now': 'Start Shopping',
    'cart.item': 'Item',
    'cart.quantity': 'Quantity',
    'cart.price': 'Price',
    'cart.total': 'Total',
    'cart.subtotal': 'Subtotal',
    'cart.shipping': 'Shipping',
    'cart.shipping_free': 'Free',
    'cart.shipping_loading': 'Calculating...',
    'cart.shipping_error': 'Unable to load shipping cost',
    'cart.shipping_warning': 'Shipping cost could not be calculated, we are temporarily applying 0€.',
    'cart.free_shipping_unlocked': 'Great! You unlocked free shipping.',
    'cart.free_shipping_missing': 'Add {amount}€ more to unlock free shipping.',
    'cart.shipping_destination': 'Estimated destination',
    'cart.shipping_destination_hint': 'Choose an area to preview shipping; at checkout we will use the address you enter.',
    'cart.checkout': 'Proceed to Checkout',
    'cart.clear_cart': 'Clear Cart',
    'cart.remove_item': 'Remove',
    'cart.item_stock_left': '{quantity} left in stock',
    'cart.item_out_of_stock': 'Currently sold out',
    'cart.order_summary': 'Order Summary',
    'cart.continue_shopping': 'Continue Shopping',
    
    // Checkout Page
    'checkout.title': 'Checkout',
    'checkout.back_to_cart': 'Back to Cart',
    'checkout.shipping_details': 'Shipping Details',
    'checkout.order_summary': 'Order Summary',
    'checkout.complete_payment': 'Complete Payment',
    'checkout.total': 'Total',
    'checkout.form.name': 'Name',
    'checkout.form.surname': 'Surname',
    'checkout.form.email': 'Email',
    'checkout.form.phone': 'Phone',
    'checkout.form.street': 'Street',
    'checkout.form.number': 'Number',
    'checkout.form.postal_code': 'Postal Code',
    'checkout.form.city': 'City',
    'checkout.form.province': 'Province',
    'checkout.form.state': 'State',
    'checkout.form.required': 'Fill in all required fields to proceed with payment',
    'checkout.payment_methods': 'Payment methods',
    'checkout.payment_methods_desc': 'Nexi, Credit/Debit Cards',
    'checkout.security': 'Security',
    'checkout.security_desc': 'Payment is handled by Nexi on a secure page',
    'checkout.subtotal': 'Subtotal',
    'checkout.shipping': 'Shipping',
    'checkout.shipping_free': 'Free',
    'checkout.shipping_loading': 'Calculating shipping...',
    'checkout.shipping_error': 'Unable to calculate shipping right now. Please try again.',
    'checkout.shipping_warning': 'Shipping could not be calculated, we are temporarily applying 0€.',
    'checkout.free_shipping_unlocked': 'Free shipping unlocked!',
    'checkout.free_shipping_missing': 'Add {amount}€ more to get free shipping.',
    'checkout.detected_zone': 'Detected destination: {zone}',
    'checkout.detected_zone_hint': 'Shipping updates automatically based on the State field.',
    'checkout.terms_intro': 'I have read, understood and accepted the',
    'checkout.terms_conditions': 'General Terms of Purchase',
    'checkout.terms_connector': 'and the',
    'checkout.terms_privacy': 'Personal Data Protection Policy pursuant to GDPR 2016/679',
    'checkout.terms_warning': 'If you do not provide consent, the purchase cannot be completed.',
    'checkout.terms_error': 'Please accept the terms and privacy policy to proceed.',

    // Terms Page
    'terms.title': 'General Terms of Purchase',
    'terms.last_update': 'Last update:',
    'terms.section_1_title': '1. General Information',
    'terms.section_1_content': 'This document defines the terms and conditions governing the use and sale of products such as books and merchandise on the Fondazione Museo Stibbert ets. e-commerce site, hereinafter the Stibbert Museum. By accessing the site and completing an order, the user fully accepts these Terms and Conditions.',
    'terms.section_2_title': '2. Scope of Service',
    'terms.section_2_content': 'The site allows users to purchase official Stibbert Museum merchandise, such as gift items, publishing products, clothing, and other merchandise.',
    'terms.section_3_title': '3. Products and Availability',
    'terms.section_3_content': 'Product descriptions and images are indicative and may not accurately represent the final product. Product availability is indicated on the site but cannot be guaranteed until the order is confirmed.',
    'terms.section_4_title': '4. Prices and Payments',
    'terms.section_4_content': 'All prices are expressed in euros (€) and include VAT, unless otherwise indicated. Payment can be made securely via Visa and Mastercard credit and debit cards through the Nexi payment system. The order is considered accepted only after payment has been confirmed.',
    'terms.section_5_title': '5. Shipping and Delivery',
    'terms.section_5_content': 'Shipping costs are indicated during the purchase process. Delivery times, specified during the purchase process, are approximate and may vary depending on the courier and destination. Deliveries are made to the address indicated by the user, and the Stibbert Museum is not responsible for any delivery errors resulting from inaccuracies or errors on the part of the user. The Stibbert Museum is not responsible for delays beyond its control. Upon delivery, users must verify the integrity of the package and its contents. In the event of any anomalies, please sign the courier\'s delivery note with a specific reservation and immediately report the defect to bookshop@museostibbert.it.',
    'terms.section_6_title': '6. Right of Withdrawal',
    'terms.section_6_content': 'Pursuant to current legislation, the user may exercise the right of withdrawal within 14 days of delivery, subject to exceptions provided by law, by giving written notice to Museo Stibbert at bookshop@museostibbert.it and, using a carrier of their choice, returning the appropriately packaged product within 14 days to: Bookshop Museo Stibbert, Via di Montughi, 4 50139 Florence. Return shipping costs are the responsibility of the user. Refunds will be issued after the integrity of the returned products has been verified.',
    'terms.section_7_title': '7. Product Warranty',
    'terms.section_7_content': 'Products are covered by a legal warranty in accordance with Italian law. Any defects must be reported within the established timeframe.',
    'terms.section_9_title': '9. Limitations of Liability',
    'terms.section_9_content': 'Museo Stibbert is not responsible for damage resulting from improper use of purchased products or for failure to fulfill the order, poor service, or delays due to force majeure. In any case, the liability of the Stibbert Museum cannot exceed the amount paid by the user to the Stibbert Museum for the purchase.',
    'terms.section_11_title': '11. Intellectual Property',
    'terms.section_11_content': 'All content on the site (text, images, trademarks, logos) is the property of the Stibbert Museum or licensed. Unauthorized use is prohibited.',
    'terms.section_12_title': '12. Privacy and Data Protection',
    'terms.section_12_content': 'The processing of personal data is governed by the Privacy Policy published on the site. Users are invited to consult it for further details.',
    'terms.section_13_title': '13. Applicable Law and Jurisdiction',
    'terms.section_13_content': 'These Terms and Conditions are governed by Italian law. Any disputes shall be subject to the jurisdiction of the consumer\'s court, except as provided by applicable law for specific cases.',
    'terms.section_14_title': '14. Changes to the Terms and Conditions',
    'terms.section_14_content': 'The Stibbert Museum reserves the right to modify these Terms and Conditions at any time. Changes will take effect from the date of publication on the site.',
    'checkout.pay_with_nexi': 'Pay with Nexi',
    'checkout.redirect_to_nexi': 'You will be redirected to Nexi secure checkout to complete the payment.',
    'checkout.processing_payment': 'Redirecting...',
    'checkout.success.title': 'Order Completed!',
    'checkout.success.message': 'Your order has been processed successfully.',
    'checkout.success.redirect': 'You will be redirected to the home page in a few seconds...',
    
    // Nexi Result / Cancel
    'nexi.result.verifying': 'Verifying your payment',
    'nexi.result.wait_message': 'We are waiting for Nexi confirmation. This may take a few seconds.',
    'nexi.result.success_title': 'Payment completed!',
    'nexi.result.success_message': 'We have received your order. A confirmation email will arrive shortly.',
    'nexi.result.failed_title': 'Payment not completed',
    'nexi.result.error_generic': 'A problem occurred while verifying the payment.',
    'nexi.result.invalid_order': 'Invalid or missing order.',
    'nexi.result.not_confirmed': 'Payment not yet confirmed by Nexi. If you already paid please contact us.',
    'nexi.result.back_home': 'Back to Home',
    'nexi.result.back_checkout': 'Back to Checkout',
    'nexi.cancel.title': 'Payment cancelled',
    'nexi.cancel.message': 'You cancelled the payment on Nexi. You can try again anytime.',
    'nexi.cancel.back_checkout': 'Try payment again',
    'nexi.cancel.back_home': 'Back to Home',
    
    // Footer
    'footer.contacts': 'Contacts',
    'footer.address': 'Via Federigo Stibbert, 26',
    'footer.hours': 'Museum Hours',
    'footer.hours_desc': 'Mon - Wed: 10:00 - 14:00',
    'footer.useful_links': 'Useful Links',
    'footer.museum_site': 'Museum Site',
    
    // Common
    'common.loading': 'Loading...',
    'common.error': 'Error',
    'common.success': 'Success',
    'common.cancel': 'Cancel',
    'common.confirm': 'Confirm',
    'common.save': 'Save',
    'common.edit': 'Edit',
    'common.delete': 'Delete',
    'common.close': 'Close',
    'common.back': 'Back',
    'common.next': 'Next',
    'common.previous': 'Previous',
    'common.required': 'Required',
    'common.optional': 'Optional'
  }
};
